<template>
  <div id="multicastGroupOverview">
    <div class="row">
      <div class="col-lg-6 mb-3">
        <properties :multicast-group="$store.getters.multicastGroup" />
      </div>

      <div class="col-lg-6">
        <end-devices :multicast-group="$store.getters.multicastGroup" />
      </div>
    </div>
  </div>
</template>

<script>
import Properties from './Properties'
import EndDevices from './EndDevices'

export default {
  titleKey: 'multicastGroupOverview',

  components: {
    Properties,
    EndDevices
  },

  props: {
    id: {
      type: String,
      default: ''
    }
  }
}
</script>
